export default "__VITE_ASSET__DfoA2yTP__"